/**
 * Route constants for the application
 * Centralized route paths to prevent hardcoding throughout the codebase
 */

export const ROUTES = {
    // DTO routes (eventually MLTA will use these too)
    ROOT: "/",
    INVITATION: "/invitation",
    QUOTE: "/quote",
    QUOTE_RESULTS: "/quote/results",

    APPLICATION: {
        ROOT: "/application",
        CONTACT: "/application/contact",
        PAYMENT: "/application/payment",
        REVIEW: "/application/review",
    },

    DECISION: {
        ROOT: "/decision",
        SUCCESS: "/decision/success",
        DENIED: "/decision/denied",
        NEEDS_CLOSER_LOOK: "/decision/needs-closer-look",
        COVERAGE_LIMIT_EXCEEDED: "/decision/coverage-limit-exceeded",
        REVIEWING_APPLICATION: "/decision/reviewing-application",
        UNABLE_TO_FINISH: "/decision/unable-to-finish",
    },

    WELCOME_BACK: "/welcome-back",
    SESSION_EXPIRED: "/session-expired",
    SYSTEM_ERROR: "/system-error",
    SOMETHING_WENT_WRONG: "/something-went-wrong",
    CONFIRM_YOUR_IDENTITY: "/confirm-your-identity",
    UNCOMPLETED_APPLICATION_EXPIRED: "/uncompleted-application-expired",
    AUTHENTICATION_FAILED: "/authentication-failed",

    // Legacy MLTA routes (temporary - until MLTA migrates)
    LEGACY_MLTA: {
        ROOT: "/",
        QUOTE: "/quote",
        QUOTE_RESULTS: "/quote/results",
        WELCOME_BACK: "/welcome-back",
        CHECK_BACK: "/check-back",
        SYSTEM_ERROR: "/system-error",
        SESSION_EXPIRED: "/session-expired",
        INVALID_LINK: "/invalid-link",

        APP: {
            PERSONAL_INFO: "/app/personal-info",
            BENEFICIARIES: "/app/beneficiaries",
            ADDRESSEE: "/app/secondary-addressee",
            HEALTH: "/app/health-statement",
            PAYMENT: "/app/payment-info",
            REVIEW: "/app/review",
            CONSENT: "/app/consent",
            PROCESSING: "/app/processing",
        },

        RESULTS: {
            APPROVED: "/results/approved",
            DECLINED: "/results/declined",
            UNABLE: "/results/unable-to-finish",
        },
    },

    // Old DTO routes (backward compatibility - redirects to clean URLs above)
    OLD_DTO: {
        ROOT: "/direct-mail-term",
        INVITATION: "/direct-mail-term/invitation",
        QUOTE: "/direct-mail-term/quote",
        WELCOME_BACK: "/direct-mail-term/welcome-back",
        SESSION_EXPIRED: "/direct-mail-term/session-expired",
        SOMETHING_WENT_WRONG: "/direct-mail-term/something-went-wrong",

        APPLICATION: {
            CONTACT: "/direct-mail-term/application/contact",
            PAYMENT: "/direct-mail-term/application/payment",
            REVIEW: "/direct-mail-term/application/review",
        },

        DECISION: {
            SUCCESS: "/direct-mail-term/decision/success",
            DENIED: "/direct-mail-term/decision/denied",
            NEEDS_CLOSER_LOOK: "/direct-mail-term/decision/needs-closer-look",
        },
    },
} as const;

/**
 * Application card fragment identifiers for contact page
 */
export const CARD_FRAGMENTS = {
    CONTACT_INFORMATION: "#contact-information",
    STATEMENT_OF_HEALTH: "#statement-of-health",
    COVERAGE_REPLACEMENT: "#coverage-replacement",
    POLICY_BENEFICIARY: "#policy-beneficiary",
    SECONDARY_ADDRESSEE: "#secondary-addressee",
} as const;
